<template>
  <div class="table-head">
    <slot></slot>
    <div style="margin-right: auto"></div>
    <slot name="right"></slot>
    <a-tooltip title="刷新">
      <a-icon class="icon" type="redo" @click="onRefresh" />
    </a-tooltip>

    <a-tooltip title="密度">
      <a-dropdown :trigger="['click']">
        <a-icon class="icon" type="column-height" />
        <a-menu slot="overlay">
          <a-menu-item @click="onTableDensityChange('default')"> 宽松 </a-menu-item>
          <a-menu-item @click="onTableDensityChange('middle')"> 默认 </a-menu-item>
          <a-menu-item @click="onTableDensityChange('small')"> 紧凑 </a-menu-item>
        </a-menu>
      </a-dropdown>
    </a-tooltip>

    <a-tooltip title="列设置">
      <a-dropdown :trigger="['click']" v-model="isShowColFilterOverlay">
        <a-icon class="icon" type="setting" @click="(e) => e.preventDefault()" />
        <a-menu slot="overlay">
          <template v-for="(item, index) in columns" @click="(e) => e.preventDefault()">
            <a-menu-item :key="index" v-if="item.title">
              <a-checkbox
                :checked="Boolean(item.show)"
                @input="(check) => onToggleColumsShow(item, check)"
                @click.stop
              >
                {{ item.title }}
              </a-checkbox>
            </a-menu-item>
          </template>
        </a-menu>
      </a-dropdown>
    </a-tooltip>
  </div>
</template>

<script>
export default {
  props: {
    onRefresh: {
      type: Function,
      required: true
    },

    size: {
      type: String,
      required: true
    },

    columns: {
      type: Array,
      required: true
    },

    settingKey: {
      type: String,
      default: 'default'
    }
  },

  data() {
    return {
      isShowColFilterOverlay: false
    }
  },

  computed: {
    storeKeySize() {
      return `${this.settingKey}_table_size`
    },

    storeKeyColumns() {
      let titleLink = this.columns.map((c) => c.title).join('-')
      return `${this.settingKey}_${titleLink}_table_colums`
    }
  },

  watch: {
    storeKeySize: {
      immediate: true,
      handler() {
        const sizeFromStore = this.$store.getters.individualizationSettings(this.storeKeySize)
        if (sizeFromStore) {
          this.onTableDensityChange(sizeFromStore)
        }
      }
    },

    storeKeyColumns: {
      immediate: true,
      handler() {
        const columsShowFromStore = this.$store.getters.individualizationSettings(
          this.storeKeyColumns
        )
        if (columsShowFromStore) {
          this.setColumsState(columsShowFromStore)
        }
      }
    }
  },

  methods: {
    onTableDensityChange(size) {
      this.$emit('update:size', size)
      this.$store.commit('Set_Individualization_Setting', { key: this.storeKeySize, value: size })
    },

    onToggleColumsShow(item, check) {
      item.show = check
      this.saveColumsState()
    },

    saveColumsState() {
      let state = {}
      this.columns.forEach((column) => {
        state[column.title] = Boolean(column.show)
      })
      this.$store.commit('Set_Individualization_Setting', {
        key: this.storeKeyColumns,
        value: state
      })
    },

    setColumsState(state) {
      this.columns.forEach((column) => {
        if (state[column.title] === undefined) return
        column.show = Boolean(state[column.title])
      })
    }
  }
}
</script>

<style lang="less" scoped>
.table-head {
  width: 100%;
  padding: 16px 0;
  display: flex;
  align-items: center;
  gap: 24px;
  font-size: 16px;

  .icon {
    cursor: pointer;

    &:hover {
      color: #0088ff;
    }
  }
}
</style>
